import { CSSProperties } from 'react';

export const BtnCss: {
  Focused: CSSProperties;
  Blured: CSSProperties;
} = {
  Focused: {
    color: '#42A9AA',
    border: '1px solid #42A9AA',
    background: '#F0FCFC',
    borderRadius: '4px',
    fontWeight: '700',
  },
  Blured: {
    color: '#363636',
    border: '1px solid #EAEAEA',
    background: 'transparent',
    borderRadius: '4px',
    fontWeight: '400',
  },
};
